import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Mail } from 'lucide-react';
import { setPageMeta } from '../utils/seo';

/**
 * StaffDirectory Page
 * Full staff directory for P.S. 155 William Paca School
 */
const StaffDirectory = () => {
  useEffect(() => {
    setPageMeta({
      title: 'Staff Directory — PS 155 William Paca School',
      description: 'Meet the teachers, administrators, and support staff of P.S. 155 William Paca School, a dual language elementary school and community school in East Harlem.',
    });
  }, []);

  const classroomTeachers = [
    { name: 'Jacquelin Rivera', email: 'JRivera82@schools.nyc.gov', role: 'Pre-K 3 Teacher' },
    { name: 'Victori Sagastume Aleman', email: 'VSagastumealeman@schools.nyc.gov', role: 'Pre-K 4 Dual Language Teacher' },
    { name: 'Reema Marji', email: 'RMarji2@schools.nyc.gov', role: 'Pre-K 4 Teacher' },
    { name: 'Andrea Sanpietro', email: 'ASanpietro2@schools.nyc.gov', role: 'Kindergarten Monolingual Teacher' },
    { name: 'Daniella Mackic', email: 'DMackic@schools.nyc.gov', role: 'Kindergarten Special Education Teacher' },
    { name: 'Vacant', email: null, role: 'Kindergarten Dual Language Teacher' },
    { name: 'Talia Chico', email: 'TChico@schools.nyc.gov', role: '1st Grade Monolingual Teacher' },
    { name: 'Vacant', email: null, role: '1st Grade Dual Language Teacher' },
    { name: 'Rosanna Velez', email: 'RVelez21@schools.nyc.gov', role: '2nd Grade Dual Language Teacher' },
    { name: 'Vacant', email: null, role: '2nd Grade Monolingual Teacher' },
    { name: 'Lissette Zurita', email: 'LZurita3@schools.nyc.gov', role: '3rd Grade Dual Language Teacher' },
    { name: 'Jenna Marlis', email: 'JMarlis2@schools.nyc.gov', role: '3rd Grade Gen Ed Teacher' },
    { name: 'Leontine Greenberg', email: 'LGreenberg12@schools.nyc.gov', role: '3rd Grade Special Education Teacher' },
    { name: 'Mariah Ramirez', email: 'MRamirez66@schools.nyc.gov', role: '4th Grade Dual Language Teacher' },
    { name: 'Daniel Gioe', email: 'DGioe3@schools.nyc.gov', role: '4th Grade Monolingual Teacher' },
    { name: 'Bryan Taveras', email: 'BTaveras5@schools.nyc.gov', role: '5th Grade Dual Language Teacher' },
    { name: 'Lucy Irace', email: 'LIrace@schools.nyc.gov', role: '5th Grade Gen Ed Teacher' },
    { name: 'Bre Anna Klag', email: 'BKlag2@schools.nyc.gov', role: '5th Grade Special Education Teacher' },
  ];

  const clusterTeachers = [
    { name: 'Roselaine Gavidia', email: 'RGavidia@schools.nyc.gov', role: 'Cluster Teacher - Art' },
    { name: 'Rebeca Christian', email: 'RChristian4@schools.nyc.gov', role: 'Cluster Teacher - Science' },
    { name: 'Minerva Gomez', email: 'MGomez62@schools.nyc.gov', role: 'Cluster Teacher - Social Studies K-2' },
    { name: 'Mishel Abramov', email: 'MAbramov2@schools.nyc.gov', role: 'Physical Education Teacher' },
  ];

  const outOfClassroom = [
    { name: 'Dorothy Sanabria', email: 'DSanabria3@schools.nyc.gov', role: 'School Principal' },
    { name: 'Jacqueline Wilson', email: 'JWilson2@schools.nyc.gov', role: 'Assistant Principal' },
    { name: 'Aimee Rodriguez', email: 'ARodriguez388@schools.nyc.gov', role: 'Bi-lingual Speech and Language Therapist' },
    { name: 'Janice Grullon', email: 'JGrullon3@schools.nyc.gov', role: 'ENL Teacher' },
    { name: 'Rosa Tavarez Martinez', email: 'rtavarezmartinez@thehome.org', role: 'Family Advocate - Wediko' },
    { name: 'Ilia Melendez', email: 'Imelend@schools.nyc.gov', role: 'Family Worker' },
    { name: 'Petros Chalkitis', email: 'PChalkitis@schools.nyc.gov', role: 'Occupational Therapist' },
    { name: 'Yelson Rivas', email: 'YRivas6@schools.nyc.gov', role: 'Paraprofessional' },
    { name: 'Tylynn Lockhart', email: 'TLockhart2@schools.nyc.gov', role: 'Paraprofessional' },
    { name: 'Delilah Gutierrez', email: 'DGutierrez@schools.nyc.gov', role: 'Paraprofessional' },
    { name: 'Dorlyn Pierre', email: 'DPierre31@schools.nyc.gov', role: 'Paraprofessional' },
    { name: 'Monique Ramos Rivera', email: 'MRamosRivera@schools.nyc.gov', role: 'Paraprofessional' },
    { name: 'Cynthia Salgado', email: 'CSalgado@schools.nyc.gov', role: 'Paraprofessional' },
    { name: 'Lucy Estevez', email: 'LEstevez7@schools.nyc.gov', role: 'Paraprofessional' },
    { name: 'Monique Stevenson', email: 'MStevenson6@schools.nyc.gov', role: 'Parent Coordinator' },
    { name: 'Lucerito Baltazar', email: 'LBaltazar2@schools.nyc.gov', role: 'School Aide' },
    { name: 'Nancy Gibollet', email: 'NGibollet@schools.nyc.gov', role: 'School Aide' },
    { name: 'Heidy Puntiel Tapia', email: 'HPuntieltapia@schools.nyc.gov', role: 'School Guidance Counselor' },
    { name: 'Nathalya Mercado', email: 'NMercado14@schools.nyc.gov', role: 'School Psychologist' },
    { name: 'Lemonia Mavrogeorgis', email: 'LMavrogeorgis@schools.nyc.gov', role: 'School Psychologist' },
    { name: 'Sheryl Pender', email: 'SPender2@schools.nyc.gov', role: 'School Secretary' },
    { name: 'Saul Rivera', email: 'saul.rivera@nypd.org', role: 'Security Agent' },
    { name: 'Lissette Herrera', email: 'LHerrera9@schools.nyc.gov', role: 'Social Worker' },
    { name: 'Nicole Gill', email: 'NGill2@schools.nyc.gov', role: 'Special Education Teacher' },
    { name: 'Cristina Battaglia', email: 'CBattaglia4@schools.nyc.gov', role: 'Speech and Language Therapist' },
    { name: 'Erica Ocasio', email: 'Eocasio7@schools.nyc.gov', role: 'Wediko Director' },
  ];

  const StaffTable = ({ staff }) => (
    <div className="overflow-x-auto rounded-2xl border border-neutral-200 shadow-md">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="bg-school-blue text-white">
            <th className="px-4 sm:px-6 py-3 sm:py-4 text-sm sm:text-base font-bold">Name</th>
            <th className="px-4 sm:px-6 py-3 sm:py-4 text-sm sm:text-base font-bold">Role</th>
            <th className="px-4 sm:px-6 py-3 sm:py-4 text-sm sm:text-base font-bold">Email</th>
          </tr>
        </thead>
        <tbody>
          {staff.map((person, index) => (
            <tr
              key={index}
              className={`border-t border-neutral-100 ${person.name === 'Vacant' ? 'bg-neutral-50 text-neutral-400 italic' : index % 2 === 0 ? 'bg-white' : 'bg-neutral-50/50'}`}
            >
              <td className="px-4 sm:px-6 py-3 sm:py-4 font-medium text-neutral-800">
                {person.name}
              </td>
              <td className="px-4 sm:px-6 py-3 sm:py-4 text-neutral-600">{person.role}</td>
              <td className="px-4 sm:px-6 py-3 sm:py-4">
                {person.email ? (
                  <a
                    href={`mailto:${person.email}`}
                    className="inline-flex items-center gap-1.5 text-school-blue hover:text-school-gold-on-blue font-medium transition-colors break-all"
                  >
                    <Mail className="w-4 h-4 shrink-0" strokeWidth={2} />
                    {person.email}
                  </a>
                ) : (
                  <span>—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="min-h-screen bg-neutral-50 font-sans text-neutral-800 selection:bg-school-gold selection:text-white">
      <Navbar />

      <main id="main-content" tabIndex="-1" className="outline-none">
        {/* Hero Section */}
        <section className="relative pt-32 sm:pt-40 md:pt-48 pb-12 sm:pb-14 md:pb-16 overflow-hidden bg-school-blue">
          <div className="absolute inset-0 bg-school-blue-dark"></div>

          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <span className="inline-block py-1 px-3 rounded-full bg-school-blue text-school-gold-on-blue text-xs sm:text-sm font-bold uppercase tracking-wider mb-3 sm:mb-4 border border-white/10">
              Our School
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 tracking-tight">
              Staff <span className="text-school-gold-on-blue">Directory</span>
            </h1>
            <div className="w-16 sm:w-20 md:w-24 h-1 bg-school-gold mx-auto mb-4 sm:mb-6 rounded-full"></div>
            <p className="text-lg sm:text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto font-light leading-relaxed px-4">
              Meet the dedicated educators and staff who make P.S. 155 a special place to learn and grow.
            </p>
          </div>
        </section>

        {/* Staff Sections */}
        <section className="py-10 sm:py-11 md:py-12 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-14 sm:space-y-16">
            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-school-blue mb-4 sm:mb-6 flex items-center gap-2 sm:gap-3">
                <span className="w-8 sm:w-12 h-1 bg-school-gold rounded-full"></span>
                Classroom Teachers
              </h2>
              <StaffTable staff={classroomTeachers} />
            </div>

            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-school-blue mb-4 sm:mb-6 flex items-center gap-2 sm:gap-3">
                <span className="w-8 sm:w-12 h-1 bg-school-gold rounded-full"></span>
                Cluster Teachers
              </h2>
              <StaffTable staff={clusterTeachers} />
            </div>

            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-school-blue mb-4 sm:mb-6 flex items-center gap-2 sm:gap-3">
                <span className="w-8 sm:w-12 h-1 bg-school-gold rounded-full"></span>
                Out of Classroom Staff
              </h2>
              <StaffTable staff={outOfClassroom} />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default StaffDirectory;
